import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { firestore } from '../../../config/firebase';
import { updateExpense } from '../../../store/actions/expenseActions';
import Spinner from '../../UIComponents/Spinner';

class AddExpense extends Component {
    state = {
        id: '',
        name: '',
        amount: 0,
        type: 'cash',
        createdAt: Date.now(),
        uzsAmount: 0,
        usdAmount: 0,
        note: '',
        msg: {
            type: 'success',
            msg: '',
            status: false
        },
        display: 'none'
    }
    componentDidMount() {
        const { id } = this.props.match.params;
        const currentExpense = this.props.expenses.find(item => item.id === id);
        this.setState({ ...this.state, ...currentExpense });
    }
    inputHandler = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    formSubmitHandler = (e) => {
        e.preventDefault();
        this.setState({ display: 'flex' })
        const { msg, readOnly, id, ...data } = this.state;
        let currencyBasedData = {};
        if (data.currency === 'UZS') {
            currencyBasedData = {
                uzsAmount: data.amount,
                usdAmount: parseFloat(data.amount / this.props.user.uzsAmount).toFixed(2)
            }
        } else {
            currencyBasedData = {
                uzsAmount: parseFloat(data.amount * this.props.user.uzsAmount).toFixed(2),
                usdAmount: data.amount
            }
        }
        firestore
            .collection('users')
            .doc(this.props.user.id)
            .collection('expenses')
            .doc(id)
            .set({ ...data, ...currencyBasedData })
            .then(doc => {
                this.setState({ msg: { msg: 'Expense has been updated successfully', type: 'success', status: true }, readOnly: true, display: 'none' });
                this.props.updateExpense({ id, ...data, ...currencyBasedData });
            })
    }
    // Close alert messages
    alertMessageHandler = () => {
        this.setState({ msg: { status: false } });
    }

    render() {
        return (
            <div id="add-expenses">
                <div
                    className={`alert alert-${this.state.msg.type} mb-5`}
                    style={{ display: this.state.msg.status ? 'block' : 'none' }}
                >
                    <strong>{this.state.msg.msg}</strong> If you want to update go to <Link to={`/expenses/${this.state.id}/edit`}>Edit</Link> page.
                    <button type="button" className="close" onClick={() => this.alertMessageHandler()}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <Spinner display={this.state.display} />
                <h3 className="mt-5">Edit - {this.state.name}</h3>
                <form onSubmit={(e) => this.formSubmitHandler(e)}>
                    <div className="form-group">
                        <label>Name</label>
                        <input
                            type="text"
                            name="name"
                            className="form-control"
                            placeholder="For Rent"
                            value={this.state.name}
                            onChange={(e) => this.inputHandler(e)}
                            readOnly={this.state.readOnly}
                        />
                    </div>
                    <div className="form-row">
                        <div className="col-8">
                            <label>Amount</label>
                            <div className="form-group d-flex expenses-amount">
                                <input
                                    type="number"
                                    name="amount"
                                    className="form-control"
                                    placeholder="1000"
                                    min="1"
                                    value={this.state.amount}
                                    onChange={(e) => this.inputHandler(e)}
                                    readOnly={this.state.readOnly}
                                />
                                <select
                                    name="currency"
                                    className="form-control"
                                    value={this.state.currency}
                                    onChange={(e) => this.inputHandler(e)}
                                >
                                    <option value="UZS">UZS</option>
                                    <option value="USD">$ - USD</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="form-group">
                                <label>Expense Type</label>
                                <select
                                    className="form-control" name="type"
                                    onChange={(e) => this.inputHandler(e)}
                                    disabled={this.state.readOnly}
                                    value={this.state.type}
                                >
                                    <option value="cash">Cash</option>
                                    <option value="card">Card</option>
                                    <option value="bank">Bank</option>
                                </select>
                            </div>
                        </div>
                    </div>


                    <div className="form-group">
                        <label>Note</label>
                        <textarea
                            className="form-control"
                            name="note"
                            rows="3"
                            onChange={(e) => this.inputHandler(e)}
                            readOnly={this.state.readOnly}
                            value={this.state.note}
                        />
                    </div>
                    <button className="btn btn-primary">Update</button>
                </form>
            </div >
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        expenses: state.expenses.expenses,
        currency: state.currency
    }
}

const mapDispatchToProps = dispatch => {
    return {
        updateExpense: (data) => dispatch(updateExpense(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AddExpense));